import * as React from 'react';
import { Card, Image } from 'react-bootstrap';
import NotificationBadge from 'react-notification-badge';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { showUpdateCustomerInfo } from '../../actions/modalActions';
import { navigateTo } from "../../actions/navigationActions";
import { addBankingDetails, hideMobileProfile, infoUpdated, updateBankingDetails, updateCustomerInfo } from '../../actions/profileActions';
import { CHOOSE_PAYMENT_DETAILS, CHOOSE_PERSONAL_DETAILS, DASHBOARD, LIFE_PAYMENT_DETAILS, LIFE_PERSONAL_DETAILS, PAYMENT_DETAILS, PERSONAL_DETAILS, PERSONAL_DETAILS_PERSONAL } from '../../routes/routes';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import SpecialDebitBanner from '../SpecialDebit/SpecialDebitBanner';
import SpecialDebitCard from '../SpecialDebit/SpecialDebitCard';
import ChoosePaymentDeets from "./ChoosePaymentDeets";
import LifePaymentDeets from "./LifePaymentDeets";
import LifePersonalDeets from "./LifePersonalDeets";
import PaymentDeets from './PaymentDeets';
import PersonalDeets from './PersonalDeets';
import './PersonalDetails.css';
import { isMobile } from 'react-device-detect';
import SpecialDebitSchedule from '../SpecialDebit/SpecialDebitSchedule';
import ChoosePersonalDeets from "./ChoosePersonalDeets";
import { NAM_COUNTRY_ID_NUMBER } from '../../constants/internationalization';


class PersonalDetails extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            currentNav: "PersonalInfo"
        };
        this.handleNav = this.handleNav.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }

    async handleNav(e: any) {
        let name = e.target.name;
        let value = e.target.id;
        await this.setState({ [name]: value });
    }

    handleClick(id) {
        this.setState({ currentNav: id });
        if (this.props.ssp?.livinEnabled && (id === CHOOSE_PAYMENT_DETAILS || id === CHOOSE_PERSONAL_DETAILS)) {
            this.handleRedirect(id);
        }
        
    }

    async componentDidMount() {
        this.props.dispatchHideProfile();
        this.setState({ currentNav: this.props.profile.goToSchedule ? "PaymentDetails" : "PersonalInfo" });
    }
    
    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }
    
    public render() {
        const isMobile = window.innerWidth <= 975;
        let nav = () =>
            <div id="PersonalDetails">
                {(!isMobile || (!this.props.profile.goToSchedule)) && <>
                    <div id="PersonalDeets">
                        <h3>My details</h3>
                        <div className="pColor mb-lg-1">
                            <p>Update and view your details here</p>
                        </div>
                    </div>
                    <Card id="PersonalInfo" className={(this.state.currentNav === "PersonalInfo" ? 'isClicked ' : '') + "fnol-progress-claim-card cursor-pointer"} onClick={() => this.handleClick(this.props.ssp?.livinEnabled ? CHOOSE_PERSONAL_DETAILS : "PersonalInfo")}>
                        <Card.Body>
                            <div className="row">
                                <div className="col-2 mt-2 align-items-center">
                                    <Image src='./Images/PersonalDetails/icons-line-style-user-grey.png' className="img-fluid image" />
                                </div>
                                <div className="col-8">
                                    <div className="row">
                                        <div className="col-12 px-0">
                                            <p className="ma-bottom-5px"><b>Personal details</b></p>
                                            <div className="notifcationBadge">
                                                <NotificationBadge count={parseInt(this.props.alertCount)} />
                                            </div>
                                        </div>
                                        <span className="content">Edit your personal info here</span>
                                    </div>
                                </div>
                                <div className={(this.state.currentNav === "PersonalInfo" ? 'd-block ' : 'd-none ') + "col-2 mt-2 text-right"}>
                                    <Image src='./Images/PersonalDetails/icons-arrow-dropdown-right-red.png' className="img-fluid mr-2" />
                                </div>
                                <div className={(this.state.currentNav !== "PersonalInfo" ? 'd-block ' : 'd-none ') + "col-2 mt-2 text-right"}>
                                    <Image src='./Images/PersonalDetails/icons-arrow-dropdown-right-grey.png' className="img-fluid mr-2" />
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card id="PaymentDetails" className={(this.state.currentNav === "PaymentDetails" ? 'isClicked ' : '') + "fnol-progress-claim-card cursor-pointer"} onClick={() => this.handleClick(this.props.ssp?.livinEnabled ? CHOOSE_PAYMENT_DETAILS : "PaymentDetails")} >
                        <Card.Body>
                            <div className="row">
                                <div className="col-2 mt-2 align-items-center">
                                    <Image src='./Images/PersonalDetails/icons-line-style-card-grey.png' className="img-fluid mr-2" />
                                </div>
                                <div className="col-8">
                                    <div className="row">
                                        <div className="col-12 px-0">
                                            <p className="ma-bottom-5px"><b>Payment details</b></p>
                                            <div className="notifcationBadge">
                                                <NotificationBadge count={parseInt(this.props.alertCount)} />
                                            </div>
                                        </div>
                                       <span className="content">{this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER ? 'Edit' : 'View'} your payment details</span>
                                    </div>
                                </div>

                                <div className={(this.state.currentNav === "PaymentDetails" ? 'd-block ' : 'd-none ') + "col-2 mt-2 text-right"}>
                                    <Image src='./Images/PersonalDetails/icons-arrow-dropdown-right-red.png' className="img-fluid mr-2" />
                                </div>
                                <div className={(this.state.currentNav !== "PaymentDetails" ? 'd-block ' : 'd-none ') + "col-2 mt-2 text-right"}>
                                    <Image src='./Images/PersonalDetails/icons-arrow-dropdown-right-grey.png' className="img-fluid mr-2" />
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </>}
                <Card id="LoginDetails" className="fnol-progress-claim-card cursor-pointer d-none" onClick={this.handleNav}>
                    <Card.Body>
                        <div className="row">
                            <div className="col-2 mt-2 align-items-center">
                                <Image src='./Images/PersonalDetails/icons-line-style-lock-grey.png' className="img-fluid mr-2" />
                            </div>
                            <div className="col-8">
                                <div className="row">
                                    <div className="col-12 px-0">
                                        <p className="ma-bottom-5px"><b>Log in details</b></p>
                                        <div className="notifcationBadge">
                                            <NotificationBadge count={parseInt(this.props.alertCount)} />
                                        </div>
                                    </div>
                                    <span className="content">Change your log in password</span>
                                </div>
                            </div>
                            <div className={(this.state.currentNav === "LoginDetails" ? 'd-block ' : 'd-none ') + "col-2 mt-2 text-right"}>
                                <Image src='./Images/PersonalDetails/icons-arrow-dropdown-right-red.png' className="img-fluid mr-2" />
                            </div>
                            <div className={(this.state.currentNav !== "LoginDetails" ? 'd-block ' : 'd-none ') + "col-2 mt-2 text-right"}>
                                <Image src='./Images/PersonalDetails/icons-arrow-dropdown-right-grey.png' className="img-fluid mr-2" />
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div >

        let info = () =>
            (this.props.ssp?.livinEnabled &&  <>
                <Route path={CHOOSE_PERSONAL_DETAILS} exact component={ChoosePersonalDeets} />
                <Route path={PERSONAL_DETAILS} exact component={ChoosePersonalDeets} />
                <Route path={CHOOSE_PAYMENT_DETAILS} exact component={ChoosePaymentDeets} />
                <Route path={PERSONAL_DETAILS_PERSONAL} exact component={PersonalDeets} />
                <Route path={LIFE_PERSONAL_DETAILS} exact component={LifePersonalDeets} />
                <Route path={PAYMENT_DETAILS} exact component={PaymentDeets} />
                <Route path={LIFE_PAYMENT_DETAILS} component={LifePaymentDeets} />
            </>) ||
            <>
                {this.state.currentNav === "PersonalInfo" &&
                    <PersonalDeets />
                }
                {this.state.currentNav === "PaymentDetails" && !this.props.profile.goToSchedule &&
                    <>
                        {isMobile && this.props.profile.hasSpecialDebitDate &&
                            <>
                                <SpecialDebitCard />
                                <br />
                            </>
                        }
                        {!isMobile && this.props.profile.hasSpecialDebitDate &&
                            <>
                                <SpecialDebitBanner />
                                <br />
                            </>
                        }
                        <PaymentDeets />
                    </>
                }
                {this.state.currentNav === "PaymentDetails" && this.props.profile.goToSchedule &&
                    <SpecialDebitSchedule />
                }
            </>
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }]

        let updated = <div id="MyDeets" className="container-fluid new-page-margins">
            {(this.state.currentNav === "PaymentDetails" && this.props.profile.goToSchedule && isMobile) && <div className='special-debit-spacing'></div>}
            <div className="new-breadcrumbwrapper breadcrumb-wrapper-capture-conditions-actual"><KPBreadCrumb navList={BreadcrumbDetails} activePage="My details" /></div>
            <div className="row new-page-main-row">
                <div className="col-lg-5 col-xl-4 col-12 col-notify-claim-nomaxwidth personal-details__nav">
                    {nav()}
                </div>
                <div className="col-lg-7 col-xl-8 col-12 nopa personal-details__info">
                    {info()}
                </div>
            </div>
        </div>

        let original = <div id="MyDeets" className="container-fluid new-page-margins">
            {(this.state.currentNav === "PaymentDetails" && this.props.profile.goToSchedule && isMobile) && <div className='special-debit-spacing'></div>}
            <div className="new-breadcrumbwrapper breadcrumb-wrapper-capture-conditions-actual"><KPBreadCrumb navList={BreadcrumbDetails} activePage="My details" /></div>
            <div className="row new-page-main-row">
                <div className="col-12 nopa d-none d-sm-none d-md-none d-lg-block d-xl-block">
                    <div className="row noma">
                        <div className="col col-notify-claim">
                            {nav()}
                        </div>
                        <div className="col">
                            {info()}
                        </div>
                    </div>
                </div>
                <div className="col-12 d-block d-sm-block d-md-block d-lg-none d-xl-none nopa">
                    <div className="row noma">
                        <div className="col-12 col-notify-claim-nomaxwidth">
                            {nav()}
                        </div>
                    </div>
                    <div className="row noma">
                        <div className="col-12 nopa">
                            {info()}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        return (
            <>
                { this.props.ssp?.livinEnabled && updated || original }
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        router: state.router,
        ssp: state.ssp,
        lifePolicy: state.lifePolicy,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchShowUpdateCustomerInfo: (field: string) => dispatch(showUpdateCustomerInfo(field)),
        dispatchUpdateCustomerInfo: (parameter: any) => dispatch(updateCustomerInfo(parameter)),
        dispatchUpdateBankingDetails: (parameter: any) => dispatch(updateBankingDetails(parameter)),
        dispatchAddBankingDetails: (parameter: any) => dispatch(addBankingDetails(parameter)),
        dispatchHideProfile: () => dispatch(hideMobileProfile()),
        dispatchInfoUpdated: () => dispatch(infoUpdated()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonalDetails);